export function openMailClient() {
  window.open(`mailto:contact@liahnson.com`, '_blank');
}
